export default "__VITE_PUBLIC_ASSET__d5ec83e7__"